<template>
  <v-tooltip right color="secondary">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mx-4"
        :absolute="absolute"
        :bottom="bottom"
        :right="right"
        :left="left"
        :fixed="fixed"
        icon
        x-small
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>
          mdi-information-outline
        </v-icon>
      </v-btn>
    </template>
    <!-- Aqui va lo que se quiere renderizar -->
    <template v-if="list">
      <v-row dense v-for="element in list" :key="element.title">
        <v-col cols="12">
          <v-icon :color="element.color">mdi-circle</v-icon>
          {{ element.title }}
        </v-col>
      </v-row>
    </template>
  </v-tooltip>
</template>

<script>
export default {
  name: "Legend",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    bottom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    top: {
      type: Boolean,
      default: false
    },
    absolute: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style>
.v-tooltip__content.menuable__content__active {
  opacity: 0.99 !important;
}
</style>
